import React from 'react';
import {useSelector} from 'react-redux';
import {Redirect} from 'react-router-dom';

import {labels} from '../../../util/utils';

import {IconoirSearch} from '@ey-xd/motif-icon';

import RightDashboardLoader from '../../Common/Loaders/RightDashboardLoader';
import EntityAccordion from './EntityAccordion';
import StyledContactDB, {StyledContactDBWrapper} from './StyledContactDB';
import Toolbar from './Toolbar';
import TemplateWithSidebar from '../../Templates/TemplateWithSidebar';
import Sidebar from '../../Common/Sidebar';
import ListWithScroll from '../../Common/ListWithScroll';

const ContactDB = () => {
	const entities = useSelector((store) => store.dashboardContext.entities);
	const data = useSelector(
		(state) =>
			state.contacts?.displayedEntities?.filter((d) => {
				return entities.some((e) => e.id === d.id && e.isEnabled);
			}) || []
	);

	const userSearch = useSelector(({contacts}) => contacts?.filters?.userSearch);
	const userPreferences = useSelector(({userPreferences}) => userPreferences);
	const project = useSelector(({project}) => project);
	const isProjectOwner = project.users
		?.filter((user) => user.isProjectOwner)
		?.some((owner) => owner.userId === userPreferences.userId);
	const hasAccess = userPreferences?.access?.contactList;
	const hasFilters = useSelector(({contacts}) => Object.keys(contacts?.filters || {}).length > 0);
	const orgChart = useSelector((store) => store.dashboardContext.orgChart);

	const renderLoader = () => <RightDashboardLoader />;

	const renderToolbar = () => <Toolbar />;

	const renderEntities = () => {
		const renderItem = (entity) => {
			const props = {key: entity.id, entity, userSearch, project, isProjectOwner};
			return <EntityAccordion {...props} />;
		};

		const props = {
			list: data,
			item: renderItem,
			Wrapper: StyledContactDB,
			includeWrapper: false
		};

		if (hasFilters) {
			props.emptyTitle = labels.noResultsFound;
			props.emptyIcon = IconoirSearch;
		}
		if (!hasFilters) {
			props.emptyTitle = labels.noEntitiesMessage1;
			props.emptySubtitle = labels.noEntitiesMessage2;
		}

		return <ListWithScroll {...props} />;
	};

	const renderSidebar = () => <Sidebar moduleLabel={labels.contactList} />;

	if (!orgChart) return <TemplateWithSidebar renderSidebar={renderSidebar}>{renderLoader()}</TemplateWithSidebar>;

	if (hasAccess) {
		return (
			<TemplateWithSidebar renderSidebar={renderSidebar} includeScroll={false}>
				<StyledContactDBWrapper>
					{renderToolbar()}
					{renderEntities()}
				</StyledContactDBWrapper>
			</TemplateWithSidebar>
		);
	} else {
		return <Redirect to="" />;
	}
};

export default ContactDB;
